import { render, staticRenderFns } from "./StrongLegalDefense.vue?vue&type=template&id=1fa0460c&"
import script from "./StrongLegalDefense.vue?vue&type=script&lang=js&"
export * from "./StrongLegalDefense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports